import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { showToast } from "./ToastSlice";
import api from "../../../axios/axiosInstance";
import {
  getAllContactsOrLeads,
  getSingleContactOrLead,
} from "../../../api/contactApi";
import { getTasksForContact } from "../../../api/taskApi";
import { getMeetingsForContact } from "../../../api/meetingApi";

// Thunk to fetch contacts with caching
export const fetchContactsWithCache = createAsyncThunk(
  "leads/fetchContactsWithCache",
  async (params = {}, { rejectWithValue, dispatch, getState }) => {
    try {
      const { page, limit, search, status, isFavourite } = params;

      // Check if this page is already cached
      const state = getState().leads;

      const cachedPage = state.cachedPages[page || 1];
      if (cachedPage) {
        // Return cached data with cached pagination
        return {
          data: cachedPage,
          pagination: state.pagination,
          fromCache: true,
          page,
        };
      }

      // Fetch from API
      const apiParams = {
        isLead: true,
        page: page || 1,
        limit: limit || 10,
        search: search || "",
        tag: "",
        sorted: false,
        category: "lead",
      };

      if (isFavourite === true) {
        apiParams.isFavourite = true;
      }

      if (status && status.length > 0) {
        apiParams.status = status;
      }

      const response = await getAllContactsOrLeads(apiParams);

      if (response.status === "success") {
        return {
          data: response.data,
          pagination: response.pagination,
          fromCache: false,
          page,
        };
      } else {
        return rejectWithValue("Failed to fetch contacts");
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      dispatch(
        showToast({
          message: error.response?.data?.message || "Failed to fetch contacts",
          type: "error",
        })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const saveBulkContacts = createAsyncThunk(
  "leads/saveBulkContacts",
  async (bulkData, { rejectWithValue, dispatch }) => {
    console.log(bulkData, "bulk data just before going to api");

    try {
      const response = await api.post("/save-bulk-contacts", {
        contacts: bulkData,
        isLead: true,
        category: "lead",
      });
      console.log(response.data, "response from bulk contacts");

      dispatch(
        showToast({
          message: response.data.message,
          variant: "success",
          delay: "10000",
        })
      );

      return response.data;
    } catch (error) {
      dispatch(
        showToast({ message: error.response.data.message, variant: "danger" })
      );
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to fetch contact details with caching
export const fetchContactDetailsWithCache = createAsyncThunk(
  "leads/fetchContactDetailsWithCache",
  async (contact_id, { rejectWithValue, getState }) => {
    try {
      // Check if contact is already cached
      const state = getState().leads;

      const cachedContact = state.contactDetailsCache[contact_id];

      if (cachedContact) {
        return { data: cachedContact, fromCache: true, contact_id };
      }

      // Fetch from API
      const response = await getSingleContactOrLead(contact_id, "lead");

      if (response.status === "success") {
        return { data: response.data, fromCache: false, contact_id };
      } else {
        return rejectWithValue("Failed to fetch contact details");
      }
    } catch (error) {
      console.error("Error fetching contact details:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to fetch tasks with caching
export const fetchTasksWithCache = createAsyncThunk(
  "leads/fetchTasksWithCache",
  async (
    { contact_id, sortBy = "descending" },
    { rejectWithValue, getState }
  ) => {
    try {
      // Check if tasks are already cached
      const state = getState().leads;
      const cachedTasks = state.tasksCache[contact_id];

      if (cachedTasks) {
        return { data: cachedTasks, fromCache: true, contact_id };
      }

      // Fetch from API
      const response = await getTasksForContact({
        contact_id,
        sortBy,
        category: "lead",
      });

      if (response.status === "success") {
        return { data: response.data, fromCache: false, contact_id };
      } else {
        return rejectWithValue("Failed to fetch tasks");
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to fetch meetings with caching
export const fetchMeetingsWithCache = createAsyncThunk(
  "leads/fetchMeetingsWithCache",
  async (
    { contact_id, sortBy = "descending" },
    { rejectWithValue, getState }
  ) => {
    try {
      // Check if meetings are already cached
      const state = getState().leads;
      const cachedMeetings = state.meetingsCache[contact_id];

      if (cachedMeetings) {
        return { data: cachedMeetings, fromCache: true, contact_id };
      }

      // Fetch from API
      const response = await getMeetingsForContact({
        contact_id,
        sortBy,
        category: "lead",
      });

      if (response.status === "success") {
        return { data: response.data, fromCache: false, contact_id };
      } else {
        return rejectWithValue("Failed to fetch meetings");
      }
    } catch (error) {
      console.error("Error fetching meetings:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// export const saveContact = createAsyncThunk(
//   "contacts/saveContact",
//   async (formData, { rejectWithValue, dispatch }) => {
//     try {
//       console.log(Object.fromEntries(formData), "formdata before going to api");

//       const response = await api.post("/addEditContact", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       console.log("Response from saveContact:", response.data);
//       dispatch(fetchContactActivities(Object.fromEntries(formData).contact_id));
//       dispatch(
//         showToast({ message: response.data.message, variant: "success" })
//       );
//       dispatch(setSelectedContact(response.data.data));
//       return response.data.data;
//     } catch (error) {
//       dispatch(
//         showToast({ message: error.response.data.message, variant: "danger" })
//       );

//       return rejectWithValue(error.response.data);
//     }
//   }
// );
// export const deleteContact = createAsyncThunk(
//   "contacts/deleteContact",
//   async (contactId, { rejectWithValue, dispatch }) => {
//     try {
//       console.log(contactId, "contact idd");

//       const response = await api.delete("/deleteContact", {
//         data: { contact_id: contactId },
//       });
//       dispatch(
//         showToast({ message: response.data.message, variant: "success" })
//       );
//       return contactId;
//     } catch (error) {
//       dispatch(
//         showToast({ message: error.response.data.message, variant: "danger" })
//       );
//       return rejectWithValue(error.response.data);
//     }
//   }
// );
// export const deleteTask = createAsyncThunk(
//   "tasks/deleteTask",
//   async (deleteTaskData, { rejectWithValue, dispatch }) => {
//     try {
//       const response = await api.delete("/deleteTask", {
//         data: deleteTaskData,
//       });
//       dispatch(
//         showToast({ message: response.data.message, variant: "success" })
//       );
//       return response.data.data.task_id;
//       // return deleteTaskData.task_id;
//     } catch (error) {
//       dispatch(
//         showToast({ message: error.response.data.message, variant: "danger" })
//       );
//       return rejectWithValue(error.response.data);
//     }
//   }
// );
// export const deleteMeeting = createAsyncThunk(
//   "meetings/deleteMeeting",
//   async (deleteMeetingData, { rejectWithValue, dispatch }) => {
//     try {
//       const response = await api.delete("/deleteMeeting", {
//         data: deleteMeetingData,
//       });

//       dispatch(
//         showToast({ message: response.data.message, variant: "success" })
//       );
//       return response.data.data.meeting_id;
//       // return deleteTaskData.task_id;
//     } catch (error) {
//       dispatch(
//         showToast({ message: error.response.data.message, variant: "danger" })
//       );
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

const contactSlice = createSlice({
  name: "leads",
  initialState: {
    contacts: [],
    cachedPages: {}, // Store contacts by page number: { 1: [...], 2: [...], etc }
    contactDetailsCache: {}, // Store contact details by contact_id
    tasksCache: {}, // Store tasks by contact_id
    meetingsCache: {}, // Store meetings by contact_id
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
    },
    // Filter/search state
    currentPage: 1,
    pageLimit: 10,
    searchQuery: "",
    selectedContactStatus: [],
    selectedIsFavourite: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Clear contacts list cache
    clearContactsCache: (state) => {
      state.cachedPages = {};
      state.contacts = [];
      state.pagination = {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
      };
      state.contactDetailsCache = {}; // Store contact details by contact_id
      state.tasksCache = {}; // Store tasks by contact_id
      state.meetingsCache = {};
      state.currentPage = 1;
      state.pageLimit = 10;
      state.searchQuery = "";
      state.selectedContactStatus = [];
      state.selectedIsFavourite = null;
    },
    // Clear contact details cache for a specific contact or all
    clearContactDetailsCache: (state, action) => {
      if (action.payload) {
        // Clear specific contact
        delete state.contactDetailsCache[action.payload];
      } else {
        // Clear all
        state.contactDetailsCache = {};
      }
    },
    // Clear tasks cache for a specific contact or all
    clearTasksCache: (state, action) => {
      if (action.payload) {
        // Clear specific contact's tasks
        delete state.tasksCache[action.payload];
      } else {
        // Clear all
        state.tasksCache = {};
      }
    },
    // Clear meetings cache for a specific contact or all
    clearMeetingsCache: (state, action) => {
      if (action.payload) {
        // Clear specific contact's meetings
        delete state.meetingsCache[action.payload];
      } else {
        // Clear all
        state.meetingsCache = {};
      }
    },
    // Update a single contact in cache (optimistic update)
    updateContactInCache: (state, action) => {
      const { contact_id, updates } = action.payload;

      // Update in current contacts array
      const currentIndex = state.contacts.findIndex(
        (c) => (c.contact_id || c._id) === contact_id
      );
      if (currentIndex !== -1) {
        state.contacts[currentIndex] = {
          ...state.contacts[currentIndex],
          ...updates,
        };
      }

      // Update in all cached pages
      Object.keys(state.cachedPages).forEach((pageNum) => {
        const pageContacts = state.cachedPages[pageNum];
        const cachedIndex = pageContacts.findIndex(
          (c) => (c.contact_id || c._id) === contact_id
        );
        if (cachedIndex !== -1) {
          state.cachedPages[pageNum][cachedIndex] = {
            ...pageContacts[cachedIndex],
            ...updates,
          };
        }
      });
    },
    // Update a single task in cache (optimistic update)
    updateTaskInCache: (state, action) => {
      const { contact_id, task_id, updates } = action.payload;

      // Update in tasksCache for this contact
      if (
        state.tasksCache[contact_id] &&
        Array.isArray(state.tasksCache[contact_id])
      ) {
        const taskIndex = state.tasksCache[contact_id].findIndex(
          (t) => t.task_id === task_id
        );
        if (taskIndex !== -1) {
          state.tasksCache[contact_id][taskIndex] = {
            ...state.tasksCache[contact_id][taskIndex],
            ...updates,
          };
        }
      }
    },
    // Delete a task from cache (optimistic update)
    deleteTaskFromCache: (state, action) => {
      const { contact_id, task_id } = action.payload;

      // Remove from tasksCache for this contact
      if (
        state.tasksCache[contact_id] &&
        Array.isArray(state.tasksCache[contact_id])
      ) {
        state.tasksCache[contact_id] = state.tasksCache[contact_id].filter(
          (t) => t.task_id !== task_id
        );
      }
    },
    // Reset entire contacts state
    resetContacts: (state) => {
      state.contacts = [];
      state.cachedPages = {};
      state.loading = false;
      state.error = null;
    },
    // Update filter/pagination values
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageLimit: (state, action) => {
      state.pageLimit = action.payload;
      // Clear cache and reset to page 1 when changing page limit
      state.cachedPages = {};
      state.currentPage = 1;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      // Clear cache and reset to page 1 when search changes
      state.cachedPages = {};
      state.currentPage = 1;
    },
    setSelectedContactStatus: (state, action) => {
      state.selectedContactStatus = action.payload;
      // Clear cache and reset to page 1 when status filter changes
      state.cachedPages = {};
      state.currentPage = 1;
    },
    setSelectedIsFavourite: (state, action) => {
      state.selectedIsFavourite = action.payload;
      // Clear cache and reset to page 1 when favourite filter changes
      state.cachedPages = {};
      state.currentPage = 1;
    },
  },

  extraReducers: (builder) => {
    // Fetch contacts with cache
    builder.addCase(fetchContactsWithCache.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(fetchContactsWithCache.fulfilled, (state, action) => {
      state.loading = false;
      const { data, fromCache, page, pagination } = action.payload;
      // Cache the page data if it's from API
      if (!fromCache) {
        state.cachedPages[page] = data;
      }

      // Update pagination if available
      if (pagination) {
        state.pagination = pagination;
      }

      // Update current contacts list
      state.contacts = data;
    });

    builder.addCase(fetchContactsWithCache.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Save bulk contacts - invalidate cache
    builder.addCase(saveBulkContacts.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(saveBulkContacts.fulfilled, (state, action) => {
      state.loading = false;
      console.log(
        action.payload.data,
        "action payload from save bulk contacts"
      );

      // Clear cache when bulk contacts are added
      state.cachedPages = {};

      // Update contacts if available
      if (
        action.payload.data &&
        Array.isArray(action.payload.data) &&
        action.payload.data.length > 0
      ) {
        action.payload.data.forEach((newContact) => {
          const index = state.contacts.findIndex(
            (c) => c.contact_id === newContact.contact_id
          );
          if (index !== -1) {
            state.contacts[index] = newContact;
          } else {
            state.contacts.push(newContact);
          }
        });
      }
    });

    builder.addCase(saveBulkContacts.rejected, (state) => {
      state.loading = false;
    });

    // Fetch contact details with cache
    builder.addCase(fetchContactDetailsWithCache.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(fetchContactDetailsWithCache.fulfilled, (state, action) => {
      state.loading = false;
      const { data, fromCache, contact_id } = action.payload;

      // Cache the contact details if it's from API
      if (!fromCache) {
        state.contactDetailsCache[contact_id] = data;
      }
    });

    builder.addCase(fetchContactDetailsWithCache.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Fetch tasks with cache
    builder.addCase(fetchTasksWithCache.fulfilled, (state, action) => {
      const { data, fromCache, contact_id } = action.payload;

      // Cache the tasks if it's from API
      if (!fromCache) {
        state.tasksCache[contact_id] = data;
      }
    });

    // Fetch meetings with cache
    builder.addCase(fetchMeetingsWithCache.fulfilled, (state, action) => {
      const { data, fromCache, contact_id } = action.payload;

      // Cache the meetings if it's from API
      if (!fromCache) {
        state.meetingsCache[contact_id] = data;
      }
    });
  },
});

export default contactSlice.reducer;
export const {
  resetContacts,
  clearContactsCache,
  updateContactInCache,
  updateTaskInCache,
  deleteTaskFromCache,
  clearContactDetailsCache,
  clearTasksCache,
  clearMeetingsCache,
  setCurrentPage,
  setPageLimit,
  setSearchQuery,
  setSelectedContactStatus,
  setSelectedIsFavourite,
} = contactSlice.actions;
